// Quotes created by a user in the Quotiss UI have no source.
export const quoteSource = {
  online: "online",
  internalEmail: "internal_email",
  externalEmail: "external_email",
};
